import { IFilterComplete } from 'src/app/filter-complete/filter-complete';

export class ReferringPhysicianSpecialityFilter implements IFilterComplete {
    public Name: string;
    public Id: number;
}
